// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VVTK0","placeholdersHeader":"styles_placeholdersHeader__1XnFa","editorStyle":"styles_editorStyle__1T2Q5","placeholdersBox":"styles_placeholdersBox__291Wl"};